/* DirectLED Theme JS v4 */

// ========== FULL-SCREEN SEARCH OVERLAY ==========
let searchTimer = null;
let lastSearchQuery = '';

function openSearch() {
  const overlay = document.getElementById('search-overlay');
  if (!overlay) return;
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => {
    const input = document.getElementById('search-overlay-input');
    if (input) input.focus();
  }, 100);
}

function closeSearch() {
  document.getElementById('search-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
  lastSearchQuery = '';
}

function clearSearch() {
  const input = document.getElementById('search-overlay-input');
  if (input) { input.value = ''; input.focus(); }
  document.getElementById('search-clear-btn').style.display = 'none';
  showSearchStartState();
}

function showSearchStartState() {
  document.getElementById('search-start-state').style.display = 'block';
  document.getElementById('search-results-area').style.display = 'none';
  document.getElementById('search-loading').style.display = 'none';
  document.getElementById('search-no-results').style.display = 'none';
}

function initSearchOverlay() {
  const input = document.getElementById('search-overlay-input');
  const overlay = document.getElementById('search-overlay');
  if (!input) return;

  input.addEventListener('input', function() {
    const q = this.value.trim();
    const clearBtn = document.getElementById('search-clear-btn');
    if (clearBtn) clearBtn.style.display = q.length > 0 ? 'block' : 'none';

    if (q === lastSearchQuery) return;
    lastSearchQuery = q;
    clearTimeout(searchTimer);

    if (q.length < 2) { showSearchStartState(); return; }

    // Show loading immediately
    document.getElementById('search-start-state').style.display = 'none';
    document.getElementById('search-results-area').style.display = 'none';
    document.getElementById('search-loading').style.display = 'block';
    document.getElementById('search-no-results').style.display = 'none';

    searchTimer = setTimeout(() => fetchOverlayResults(q), 250);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && this.value.trim()) {
      window.location.href = `/search?type=product&q=${encodeURIComponent(this.value.trim())}`;
    }
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Click backdrop to close
  overlay?.addEventListener('click', function(e) {
    if (e.target === overlay) closeSearch();
  });
}

function fetchOverlayResults(query) {
  const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[fields]=title,product_type,variants.title,variants.sku,vendor,tag`;

  fetch(url)
    .then(r => {
      if (!r.ok) throw new Error('Search API returned ' + r.status);
      return r.json();
    })
    .then(data => {
      const products = data?.resources?.results?.products || [];
      renderOverlayResults(products, query);
    })
    .catch(err => {
      console.warn('DirectLED Search error:', err);
      // If store is password protected or API fails, fall back to results page
      document.getElementById('search-loading').style.display = 'none';
      const noResults = document.getElementById('search-no-results');
      if (noResults) {
        noResults.style.display = 'block';
        noResults.innerHTML = '<p class="search-empty-title">Search unavailable in preview mode</p><p class="search-empty-sub">Press Enter to search, or <a href="/collections/all" onclick="closeSearch()">browse all products</a></p>';
      }
    });
}

function renderOverlayResults(products, query) {
  document.getElementById('search-loading').style.display = 'none';

  if (products.length === 0) {
    document.getElementById('search-results-area').style.display = 'none';
    document.getElementById('search-no-results').style.display = 'block';
    return;
  }

  document.getElementById('search-no-results').style.display = 'none';
  document.getElementById('search-results-area').style.display = 'block';

  const grid = document.getElementById('search-results-grid');
  const viewAllWrap = document.getElementById('search-view-all-wrap');
  const viewAllLink = document.getElementById('search-view-all-link');

  grid.innerHTML = products.map(p => {
    const imgHtml = p.image
      ? `<img src="${p.image}" alt="${esc(p.title)}" loading="lazy">`
      : `<svg width="40" height="40" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="14" stroke="rgba(255,255,255,.2)" stroke-width="1.5"/></svg>`;

    const desc = p.body
      ? p.body.replace(/<[^>]+>/g, '').substring(0, 70) + '…'
      : '';

    const sku = p.variants?.[0]?.sku || '';
    const tag = p.product_type || '';

    // Spec tags from SKU or product type
    const specs = [];
    if (sku) specs.push(sku);
    if (tag) specs.push(tag);

    return `
      <a href="${p.url}" class="search-product-card" onclick="closeSearch()">
        <div class="search-product-card-img">${imgHtml}</div>
        <div class="search-product-card-body">
          ${tag ? `<div class="search-product-card-tag">${esc(tag)}</div>` : ''}
          <div class="search-product-card-title">${highlight(p.title, query)}</div>
          ${desc ? `<div class="search-result-desc" style="font-size:11px;color:rgba(255,255,255,.45);margin-bottom:6px;line-height:1.4">${esc(desc)}</div>` : ''}
          ${sku ? `<div class="search-product-card-specs"><span class="search-product-card-spec">${esc(sku)}</span></div>` : ''}
        </div>
      </a>`;
  }).join('');

  if (viewAllWrap && viewAllLink) {
    viewAllWrap.style.display = 'block';
    viewAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    viewAllLink.textContent = `View all results for "${query}" →`;
  }
}

function highlight(text, query) {
  if (!text || !query) return esc(text || '');
  const safeQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return esc(text).replace(new RegExp(`(${safeQuery})`, 'gi'), '<mark>$1</mark>');
}

function esc(str) {
  return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

// ========== PRODUCT TABS ==========
function switchTab(btn, tabId) {
  document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
  document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById('tab-' + tabId)?.classList.add('active');
}

// ========== PRODUCT THUMBNAILS ==========
function setMainImage(thumb) {
  document.querySelectorAll('.product-thumbnail').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
  const img = document.getElementById('main-product-image');
  if (img && thumb.dataset.imageUrl) img.src = thumb.dataset.imageUrl;
}

// ========== PRODUCT VARIANTS ==========
function handleOptionSelect(pill) {
  const idx = parseInt(pill.dataset.optionIndex);
  document.querySelector(`.option-pills[data-option-index="${idx}"]`)
    ?.querySelectorAll('.option-pill').forEach(p => p.classList.remove('selected'));
  pill.classList.add('selected');
  const span = document.getElementById(`selected-val-${idx + 1}`);
  if (span) span.textContent = ': ' + pill.dataset.value;
  updateVariantFromSelections();
}

function updateVariantFromSelections() {
  if (!window.productData) return;
  const opts = [];
  document.querySelectorAll('.option-pills').forEach(g => {
    const s = g.querySelector('.option-pill.selected');
    if (s) opts.push(s.dataset.value);
  });
  const match = window.productData.variants.find(v => v.options.every((o, i) => o === opts[i]));
  if (!match) return;
  document.getElementById('selected-variant-id').value = match.id;
  const skuEl = document.getElementById('sku-display');
  if (skuEl && match.sku) skuEl.textContent = match.sku;
  if (typeof refreshProductCTA === 'function') {
    refreshProductCTA();
  } else {
    const btn = document.getElementById('add-to-quote-btn');
    if (btn) {
      btn.onclick = () => addToQuote(window.productData.id,
        document.querySelector('.product-title')?.textContent?.trim() || '',
        match.sku || window.productData.handle,
        document.getElementById('main-product-image')?.src || '',
        window.location.pathname,
        document.getElementById('product-cta-wrap')?.dataset.specUrl || '');
    }
  }
  if (match.featured_image?.src) {
    const img = document.getElementById('main-product-image');
    if (img) img.src = match.featured_image.src;
  }
}

// ========== QUOTE CART ==========
let quoteItems = [];
try { quoteItems = JSON.parse(localStorage.getItem('dl_quote') || '[]'); } catch(e) { quoteItems = []; }

function saveQuote() {
  try { localStorage.setItem('dl_quote', JSON.stringify(quoteItems)); } catch(e) {}
  updateQuoteBadge();
  if (typeof refreshOrderCart === 'function') refreshOrderCart();
}

function updateQuoteBadge() {
  const count = quoteItems.reduce((s, i) => s + (i.qty || 1), 0);
  const badge = document.getElementById('quote-badge');
  const bar = document.getElementById('quote-cart-bar');
  if (badge) badge.textContent = count;
  if (bar) bar.style.display = count > 0 ? 'block' : 'none';
  renderQuoteItems();
}

function addToQuote(pid, title, sku, imgUrl, url, specUrl) {
  if (!sku || sku === 'N/A') {
    const m = (url || '').split('/products/')[1];
    sku = m ? m.split('?')[0].split('/')[0] : '';
  }
  const ex = quoteItems.find(i => i.id === pid && i.sku === sku);
  if (ex) { ex.qty = (ex.qty || 1) + 1; }
  else { quoteItems.push({ id: pid, title, sku, img: imgUrl, url: url || '', spec: specUrl || '', qty: 1, description: '', type: '' }); }
  saveQuote();
  openQuoteDrawer();
  const btn = document.getElementById('add-to-quote-btn');
  if (btn) {
    btn.textContent = '✓ Added!';
    btn.style.background = 'var(--green-dark)';
    setTimeout(() => { btn.textContent = '+ Add to Quote'; btn.style.background = ''; }, 2000);
  }
}

function renderQuoteItems() {
  const c = document.getElementById('quote-items');
  const footer = document.getElementById('quote-footer');
  if (!c) return;
  if (!quoteItems.length) {
    c.innerHTML = '<div class="quote-empty"><p>Your quote list is empty.<br>Add products to get started.</p></div>';
    if (footer) footer.style.display = 'none';
    return;
  }
  if (footer) footer.style.display = 'block';
  c.innerHTML = quoteItems.map((item, i) => `
    <div class="quote-item">
      <div class="quote-item-img">${item.img ? `<img src="${item.img}" alt="">` : ''}</div>
      <div class="quote-item-info">
        <div class="quote-item-title">${esc(item.title)}</div>
        <div class="quote-item-sku">SKU: ${esc(item.sku || 'N/A')}</div>
        <div class="quote-item-qty">
          <button class="qty-btn" onclick="changeQty(${i},-1)">−</button>
          <span class="qty-val">${item.qty || 1}</span>
          <button class="qty-btn" onclick="changeQty(${i},1)">+</button>
        </div>
        <textarea class="quote-item-desc" placeholder="Add a note for this item (optional)" oninput="updateItemDescription(${i}, this.value)">${esc(item.description || '')}</textarea>
        <input type="text" class="quote-input" style="margin-top:6px;font-size:11px;padding:5px 8px" placeholder="Type (optional, e.g. A1)" value="${esc(item.type || '')}" oninput="updateItemType(${i}, this.value)">
      </div>
      <button class="quote-item-remove" onclick="removeQuoteItem(${i})">✕</button>
    </div>`).join('');
}

function updateItemDescription(i, value) {
  if (quoteItems[i]) {
    quoteItems[i].description = value;
    try { localStorage.setItem('dl_quote', JSON.stringify(quoteItems)); } catch(e) {}
  }
}

function updateItemType(i, value) {
  if (quoteItems[i]) {
    quoteItems[i].type = value;
    try { localStorage.setItem('dl_quote', JSON.stringify(quoteItems)); } catch(e) {}
  }
}

function changeQty(i, d) {
  if (quoteItems[i]) { quoteItems[i].qty = Math.max(1, (quoteItems[i].qty || 1) + d); saveQuote(); }
}
function removeQuoteItem(i) { quoteItems.splice(i, 1); saveQuote(); }
function clearQuote() { if (confirm('Clear all items?')) { quoteItems = []; saveQuote(); closeQuoteDrawer(); } }
function toggleQuoteDrawer() { document.getElementById('quote-drawer')?.classList.contains('open') ? closeQuoteDrawer() : openQuoteDrawer(); }
function openQuoteDrawer() { document.getElementById('quote-drawer')?.classList.add('open'); document.getElementById('quote-overlay')?.classList.add('show'); renderQuoteItems(); }
function closeQuoteDrawer() { document.getElementById('quote-drawer')?.classList.remove('open'); document.getElementById('quote-overlay')?.classList.remove('show'); }

function submitQuote() {
  const c = getQuoteContact();
  if (!c.name || !c.email) { alert('Please enter your name and email.'); return; }
  if (!quoteItems.length) { alert('Quote list is empty.'); return; }
  const btn = document.getElementById('quote-submit-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  DLDocs.notifyRequest('Quote Request', quoteItems, c);
  setTimeout(() => {
    document.getElementById('quote-success').style.display = 'block';
    if (btn) { btn.disabled = false; btn.textContent = 'Send Quote Request →'; }
    setTimeout(() => { document.getElementById('quote-success').style.display = 'none'; }, 5000);
  }, 600);
}

function getQuoteContact() {
  return {
    name: (document.getElementById('q-name') || { value: '' }).value.trim(),
    company: (document.getElementById('q-company') || { value: '' }).value.trim(),
    email: (document.getElementById('q-email') || { value: '' }).value.trim(),
    phone: (document.getElementById('q-phone') || { value: '' }).value.trim(),
    job: (document.getElementById('q-project') || { value: '' }).value.trim(),
    address: (document.getElementById('q-project') || { value: '' }).value.trim(),
    dist: (document.getElementById('q-distributor') || { value: '' }).value.trim(),
    notes: (document.getElementById('q-notes') || { value: '' }).value.trim()
  };
}

function validateQuoteDocContact(c) {
  if (!c.name || !c.email) { alert('Please enter your name and email.'); return false; }
  if (!c.job) { alert('Please enter a project/job name.'); return false; }
  return true;
}

function downloadQuoteSubmittal() {
  if (!quoteItems.length) { alert('Your quote list is empty.'); return; }
  const c = getQuoteContact();
  if (!validateQuoteDocContact(c)) return;
  const btn = document.getElementById('quote-submittal-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Generating PDF…'; }
  DLDocs.notifyRequest('PDF Download', quoteItems, c);
  DLDocs.downloadSubmittalPDF(quoteItems, c)
    .catch(err => { console.error(err); alert('PDF generation failed:\n' + err.message); })
    .finally(() => { if (btn) { btn.disabled = false; btn.textContent = '📄 Download Submittal PDF'; } });
}

function generateQuoteSchedule() {
  if (!quoteItems.length) { alert('Your quote list is empty.'); return; }
  const c = getQuoteContact();
  if (!validateQuoteDocContact(c)) return;
  const btn = document.getElementById('quote-schedule-btn');
  if (btn) { btn.disabled = true; btn.textContent = 'Building schedule…'; }
  DLDocs.notifyRequest('Excel Schedule', quoteItems, c);
  DLDocs.generateScheduleExcel(quoteItems, c)
    .catch(err => { console.error(err); alert('Could not build the schedule. Please try again.'); })
    .finally(() => { if (btn) { btn.disabled = false; btn.textContent = '📄 Generate Schedule (Excel)'; } });
}

// ========== MOBILE MENU ==========
function toggleMobileMenu() {
  const open = document.getElementById('mobile-drawer')?.classList.toggle('open');
  document.getElementById('mobile-overlay')?.classList.toggle('show', open);
  document.querySelector('.mobile-burger')?.setAttribute('aria-expanded', open ? 'true' : 'false');
}
function closeMobileMenu() {
  document.getElementById('mobile-drawer')?.classList.remove('open');
  document.getElementById('mobile-overlay')?.classList.remove('show');
  document.querySelector('.mobile-burger')?.setAttribute('aria-expanded', 'false');
}

// Mobile filter toggle
function toggleFilters() {
  const body = document.getElementById('filters-body');
  const btn = document.getElementById('filters-toggle');
  const icon = document.getElementById('filters-toggle-icon');
  const open = body?.classList.toggle('open');
  btn?.classList.toggle('open', open);
  if (icon) icon.textContent = open ? '✕' : '+';
}

// ========== INIT ==========
document.addEventListener('DOMContentLoaded', function() {
  initSearchOverlay();
  updateQuoteBadge();

  if (window.productData) {
    const btn = document.getElementById('add-to-quote-btn');
    const titleEl = document.querySelector('.product-title');
    if (btn && titleEl && btn.dataset.loggedIn !== 'true') {
      const v = window.productData.variants[0];
      btn.onclick = () => addToQuote(
        window.productData.id, titleEl.textContent.trim(),
        document.getElementById('sku-display')?.textContent || v?.sku || window.productData.handle,
        document.getElementById('main-product-image')?.src || '',
        window.location.pathname,
        document.getElementById('product-cta-wrap')?.dataset.specUrl || '');
    }
  }

  document.addEventListener('click', e => {
    if (!e.target.closest('.mobile-drawer') && !e.target.closest('.mobile-burger')) closeMobileMenu();
  });
});
